import { Element } from "@xmpp/xml"
import { ReferenceRouteStatus } from "reducers/referenceRouteStatusesSlice"
import PubSubEventParser from "./PubSubEventParser"

class ReferenceRouteStatusParser {
  static readonly NAMESPACE = "urn:slickshift:reference-route:0"

  static parse(stanza: Element): ReferenceRouteStatus | undefined {
    const item = stanza?.getChild("reference-route", this.NAMESPACE)

    if (!item) return

    return {
      jid: stanza.getAttr("id"),
      isOffRoute: item.getAttr("is_off_route") === "1",
    }
  }
}

export const ReferenceRouteStatusPubSubParser =
  new PubSubEventParser<ReferenceRouteStatus>(
    ReferenceRouteStatusParser.parse,
    ReferenceRouteStatusParser.NAMESPACE,
  )
